export default "__VITE_ASSET__BJtjAuLY__"